import { render, staticRenderFns } from "./LocationSection.vue?vue&type=template&id=05de17ca&scoped=true"
import script from "./LocationSection.vue?vue&type=script&lang=js"
export * from "./LocationSection.vue?vue&type=script&lang=js"
import style0 from "./LocationSection.vue?vue&type=style&index=0&id=05de17ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de17ca",
  null
  
)

export default component.exports